import { createDuck } from '@/utils'
import { getOrderDetailById } from '@/services/api/orders'
import { Toast } from 'antd-mobile-v2'

/** @type {object} */
export const DEFAULT_STATUS = {
  status: 0,
}
export const duck = createDuck({
  name: 'evaluateDuck',
  initialState: {},
  actions: {
    /**
     * 根据orderId 获取订单详情
     * @param {number} orderId
     * @returns
     */
    fetchData(orderId) {
      return async dispatch => {
        // const { evaluateDuck } = getState()
        const { data, error } = await getOrderDetailById(orderId)
        if (!error) {
          //订单商品id。注意：不是itemId！不是itemId！不是itemId！是订单列表和订单详情中，返回的items.id。若对接有疑问，请咨询商城开发人员
          const _list = Array.isArray(data.items) ? data.items : []
          const entities = {}
          const list = _list.map(item => {
            entities[item.id] = {
              ...item,
              rate: 5,
              fileList: [],
            }
            return item.id
          })
          // const { list, entities } = createEntityCollection(data.items, item => item.id)

          dispatch(
            duck.change({
              [orderId]: {
                status: 1,
                list,
                entities,
                orderId,
              },
            }),
          )
        } else {
          Toast.show(error.message || '获取订单数据失败')
        }
      }
    },

    changeStatus(val, orderId) {
      return async dispatch => {
        dispatch(
          duck.change({
            [orderId]: {
              status: val,
            },
          }),
        )
      }
    },
    changeItemRate(rate, orderId, id) {
      return async (dispatch, getState) => {
        const { evaluateDuck } = getState()
        const { entities, ...ot } = evaluateDuck[orderId]
        dispatch(
          duck.change({
            [orderId]: {
              ...ot,
              entities: {
                ...entities,
                [id]: {
                  ...entities[id],
                  rate: rate,
                },
              },
            },
          }),
        )
      }
    },

    changeFileList(list, orderId, id) {
      return async (dispatch, getState) => {
        const { evaluateDuck } = getState()
        const { entities, ...ot } = evaluateDuck[orderId]
        dispatch(
          duck.change({
            [orderId]: {
              ...ot,
              entities: {
                ...entities,
                [id]: {
                  ...entities[id],
                  fileList: list,
                },
              },
            },
          }),
        )
      }
    },
    changeInput(value, orderId, id) {
      return async (dispatch, getState) => {
        const { evaluateDuck } = getState()
        const { entities, ...ot } = evaluateDuck[orderId]
        dispatch(
          duck.change({
            [orderId]: {
              ...ot,
              entities: {
                ...entities,
                [id]: {
                  ...entities[id],
                  input: value,
                },
              },
            },
          }),
        )
      }
    },
  },
})
